"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject, _class, _FlagTaiwanIcon;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagTaiwanIcon = (0, _mobxReact.observer)(_class = (_FlagTaiwanIcon = /*#__PURE__*/function (_React$Component) {
  function FlagTaiwanIcon() {
    _classCallCheck(this, FlagTaiwanIcon);
    return _callSuper(this, FlagTaiwanIcon, arguments);
  }
  _inherits(FlagTaiwanIcon, _React$Component);
  return _createClass(FlagTaiwanIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 100 100",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#FF5252",
        x: "0",
        y: "0",
        width: "100",
        height: "100"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#000091",
        x: "0",
        y: "0",
        width: "69",
        height: "65"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        id: "Group",
        transform: "translate(21.000000, 18.000000)",
        fill: "#F8F8F8"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "19 0.4 17 8.2 21 8.2"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "19 0.4 17 8.2 21 8.2"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "19 37.4 17 29.5 21 29.5"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "37.5 18.8 29.7 16.9 29.7 20.9"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "0.5 18.8 8.4 16.9 8.4 20.9"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "28.3 2.9 22.7 8.7 26.2 10.7"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "9.6 34.8 11.9 27 15.4 29.1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "35 28.2 29.2 22.5 27.2 26"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "3.1 9.4 10.9 11.7 8.8 15.2"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "35 9.6 27.2 11.8 29.3 15.3"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "2.9 28 8.8 22.4 10.8 25.9"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "28.3 34.9 26.1 27.1 22.6 29.1"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        points: "9.9 2.8 15.5 8.6 12 10.6"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        cx: "19.1",
        cy: "18.9",
        r: "9.5"
      })))));
    }
  }]);
}(_react["default"].Component), _FlagTaiwanIcon.defaultProps = {
  width: '20px'
}, _FlagTaiwanIcon)) || _class;
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagTaiwanIcon);